import React from 'react';
import { connect } from 'react-redux';

import {
    devicesLoadingSelector,
} from '~/features/devices/selectors/controlDeviceSelectors';
import { showControlDeviceEditor } from '~/features/devices/actions/controlDeviceEditorActions';
import { deviceRowDescriptors } from '~/features/oldVehicles/components/devices/constants/deviceRowDescriptors';
import { defaultNetworkCodeSelector } from '~/features/base/selectors/defaultNetworkCodeSelector';
import DevicePropertiesTable from '~/features/oldVehicles/components/devices/DevicePropertiesTable';

interface OwnProps {
    controlDeviceInfo?: any;
}

interface StateProps {
    deviceDetailsLoading: boolean;
    defaultNetworkCodeList?: any[];
}

interface DispatchProps {
    showControlDeviceEditor: (payload: { isNew: boolean; serialNumber: string }) => void;
}

type Props = OwnProps & StateProps & DispatchProps;

/**
 * Container for the device properties
 */
export const DevicePropertiesContainer: React.FC<Props> = ({
    controlDeviceInfo,
    defaultNetworkCodeList,
}) => {
    const controlDeviceData = { ...controlDeviceInfo, networkCodeList: defaultNetworkCodeList };

    return (
        <DevicePropertiesTable
            controlDeviceData={controlDeviceData}
            rowDescriptors={deviceRowDescriptors}
        />
    );
};

export const mapStateToProps = (state: any): StateProps => {
    return {
        deviceDetailsLoading: devicesLoadingSelector(state),
        defaultNetworkCodeList: defaultNetworkCodeSelector(state),
    };
};

export const mapDispatchToProps = (dispatch: any): DispatchProps => {
    return {
        showControlDeviceEditor: payload => {
            dispatch(showControlDeviceEditor(payload));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DevicePropertiesContainer);
